import type { ApiEmbedSearchWidgetId } from 'api/types/ApiTypedId';

const embedSearchWidgetRoutePrefix = '/embed-search-widget/';

export function getEmbedSearchWidgetIdFromPathname(
  pathname: string,
): ApiEmbedSearchWidgetId | undefined {
  if (!pathname.startsWith(embedSearchWidgetRoutePrefix)) return;

  return pathname.replace(embedSearchWidgetRoutePrefix, '').split('/')[0];
}
